var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2219 2.34689L7.59692 7.97189C7.51854 8.05055 7.42539 8.11297 7.32283 8.15555C7.22027 8.19814 7.11032 8.22006 6.99927 8.22006C6.88822 8.22006 6.77826 8.19814 6.6757 8.15555C6.57314 8.11297 6.48 8.05055 6.40161 7.97189L0.77661 2.34689C0.618102 2.18839 0.529053 1.9734 0.529053 1.74924C0.529053 1.52507 0.618102 1.31009 0.77661 1.15158C0.935118 0.993072 1.1501 0.904024 1.37427 0.904024C1.59843 0.904024 1.81341 0.993072 1.97192 1.15158L6.99997 6.17963L12.028 1.15088C12.1865 0.99237 12.4015 0.90332 12.6257 0.90332C12.8498 0.90332 13.0648 0.99237 13.2233 1.15088C13.3818 1.30939 13.4709 1.52437 13.4709 1.74853C13.4709 1.9727 13.3818 2.18768 13.2233 2.34619L13.2219 2.34689Z",
    fill: "#F1E1D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9de1b67d653c0bf5461d70c297d0253f.svg";
export { ForwardRef as ReactComponent };